var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M454.2,196H60.5c-19.8,0-35.9-16.1-35.9-35.9v-55.2C24.6,85.1,40.7,69,60.5,69h393.7 c19.8,0,35.9,16.1,35.9,35.9v55.2C490.1,179.9,474.1,196,454.2,196z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M328.1,5.5H186.6c-19.8,0-35.9,16.1-35.9,35.9v55.2c0,19.8,16.1,35.9,35.9,35.9h141.5 c19.8,0,35.9-16.1,35.9-35.9V41.4C364,21.6,347.9,5.5,328.1,5.5z M317.9,102.7h-121V45.3h121V102.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M65.7,221v255.1c0,19.8,16.1,35.9,35.9,35.9h311.4c19.8,0,35.9-16.1,35.9-35.9V221H65.7z M193.4,414.7 c0,6.6-5.4,12-12,12h-18.7c-6.6,0-12-5.4-12-12V268c0-6.6,5.4-12,12-12h18.7c6.6,0,12,5.4,12,12V414.7z M278.7,414.7 c0,6.6-5.4,12-12,12H248c-6.6,0-12-5.4-12-12V268c0-6.6,5.4-12,12-12h18.7c6.6,0,12,5.4,12,12V414.7z M364,414.7c0,6.6-5.4,12-12,12 h-18.7c-6.6,0-12-5.4-12-12V268c0-6.6,5.4-12,12-12H352c6.6,0,12,5.4,12,12V414.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDelete);
export default __webpack_public_path__ + "static/media/button-delete.f6548e9a62399badd30e719155dc12cb.svg";
export { ForwardRef as ReactComponent };